'use es6';

import { createSelector } from 'reselect';
import { getHasStagingDomain } from 'ContentEditorUI/redux/selectors/contentSchemaSelectors';
import { getIsSitePage } from 'ContentEditorUI/redux/selectors/contentReadOnlyDataSelectors';
const getNonStagingContentTypeKey = createSelector([getIsSitePage], isSitePage => isSitePage ? 'site' : 'landing');
export const getContentTypeKey = createSelector([getHasStagingDomain, getNonStagingContentTypeKey], (hasStagingDomain, nonStagingContentTypeKey) => hasStagingDomain ? 'staging' : nonStagingContentTypeKey);
export const getTranslationKey = getContentTypeKey;
export const getContentTypeNounKey = createSelector([getIsSitePage], isSitePage => isSitePage ? 'categories.site_page' : 'categories.landing_page');